import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const BLOCKER_CONTEXT_SYMBOL = Symbol();
const useBlocker = () => useImmutableContext(BLOCKER_CONTEXT_SYMBOL);
const useBlockerProvider = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return useImmutableContextProvider(BLOCKER_CONTEXT_SYMBOL, ...args);
};
export { useBlocker, useBlockerProvider };